import clsx from 'clsx';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
  type AriaLabelingProps,
} from '@dynatrace/strato-components/core';
import { _useAriaLabelingProps } from '@dynatrace/strato-components/core';

import {
  suggestionGroupCSS,
  suggestionGroupListCSS,
} from './SuggestionGroup.sty.js';

/**
 * Accepted properties for FilterField suggestion group.
 * @public
 */
export type FilterFieldSuggestionGroupProps = WithChildren &
  AriaLabelingProps &
  StylingProps &
  DataTestId;

/**
 * @public
 */
export const SuggestionGroup = (props: FilterFieldSuggestionGroupProps) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
    ...remainingProps
  } = props;
  const ariaLabelingProps = _useAriaLabelingProps(remainingProps);

  return (
    <li
      data-testid={dataTestId}
      className={clsx(suggestionGroupCSS, consumerClassName)}
      style={consumerStyle}
    >
      <ul
        role="group"
        className={suggestionGroupListCSS}
        {...ariaLabelingProps}
      >
        {children}
      </ul>
    </li>
  );
};

SuggestionGroup.displayValue = 'FilterField.SuggestionGroup';
